import enUSLanguageJson from "../assets/languages/en-US";
import zhCNLanguageJson from "../assets/languages/zh-CN";

export function getLanguageJsonDefinition(lang: string, clientName: string) {
  return {
    "en-US": enUSLanguageJson(clientName),
    "zh-CN": zhCNLanguageJson(clientName)
  }[lang];
}